import React, { useRef } from 'react';
import { getIconClass } from '../../../helpers';
import { Autocomplete } from '@react-google-maps/api';
import { useFormContext } from '../../../providers';


export const MailingAddressSection = () => {
    // Use React Hook Form with Yup validation
    const {
        register,
        setValue,
        errors,
        getValues,
        fieldRefs
    } = useFormContext();

    const autocompleteRef = useRef(null);

    // Handle place selection
    const handlePlaceSelect = () => {
        const place = autocompleteRef.current.getPlace();

        if (place && place.address_components) {
            const address = place.address_components;
            const streetAddress = place.formatted_address;

            // Only update if the value is different to prevent infinite loop
            if (streetAddress !== getValues('address')) {
                setValue('address', streetAddress);
            }

            address.forEach((component) => {
                if (component.types.includes('locality')) {
                    // Only set value if it's different to avoid unnecessary re-renders
                    if (component.long_name !== getValues('city')) {
                        setValue('city', component.long_name);
                    }
                }
                if (component.types.includes('administrative_area_level_1')) {
                    if (component.long_name !== getValues('state')) {
                        setValue('state', component.long_name);
                    }
                }
                if (component.types.includes('postal_code')) {
                    if (component.long_name !== getValues('zip_code')) {
                        setValue('zip_code', component.long_name);
                    }
                }
                if (component.types.includes('country')) {
                    if (component.long_name !== getValues('country')) {
                        setValue('country', component.long_name);
                    }
                }
            });
        }
    };

    return (
        <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-md">

            <div className="dashboard-title" style={{ display: 'flex', justifyContent: 'center' }}>
                <h3>Mailing Address</h3>
            </div>

            <div>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div ref={(el) => (fieldRefs.current["address"] = el)}>
                        <label className="block text-sm font-medium">
                            Street Address <i className={getIconClass('Street Address')} />
                        </label>
                        <Autocomplete
                            onLoad={(ref) => (autocompleteRef.current = ref)}
                            onPlaceChanged={handlePlaceSelect}
                        >
                            <input
                                className="w-full p-2 border rounded-md"
                                type="text"
                                placeholder="Enter street address"
                                {...register('address', { onChange: (e) => setValue('address', e.target.value, { shouldValidate: true }) })}

                            />
                        </Autocomplete>
                        {errors.address && (
                            <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.address.message}</span>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium">
                            Apartment/Suite (optional) <i className={getIconClass('Apt, Suite')} />
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded-md"
                            placeholder="Apartment/Suite (optional)"
                            {...register('unit_no')}
                        />
                    </div>

                    <div style={{ marginTop: '12px' }} ref={(el) => (fieldRefs.current["city"] = el)}>
                        <label className="block text-sm font-medium">
                            City <i className={getIconClass('City')} />
                        </label>
                        <input type="text" placeholder="City"
                            className="w-full p-2 border rounded-md"
                            {...register('city', { onChange: (e) => setValue('city', e.target.value, { shouldValidate: true }) })}
                        />
                        {errors.city && <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.city.message}</span>}
                    </div>

                    <div style={{ marginTop: '12px' }} ref={(el) => (fieldRefs.current["state"] = el)}>
                        <label className="block text-sm font-medium">
                            State <i className={getIconClass('State')} />
                        </label>
                        <input type="text" placeholder="State"
                            className="w-full p-2 border rounded-md"
                            {...register('state', { onChange: (e) => setValue('state', e.target.value, { shouldValidate: true }) })}
                        />
                        {errors.state && <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.state.message}</span>}
                    </div>

                    <div style={{ marginTop: '12px' }} ref={(el) => (fieldRefs.current["zip_code"] = el)}>
                        <label className="block text-sm font-medium">
                            ZIP / Postal code <i className={getIconClass('ZIP / Postal code')} />
                        </label>
                        <input type="text" placeholder="ZIP / Postal code"
                            className="w-full p-2 border rounded-md"
                            {...register('zip_code', { onChange: (e) => setValue('zip_code', e.target.value, { shouldValidate: true }) })}
                        />
                        {errors.zip_code && <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.zip_code.message}</span>}
                    </div>

                    <div style={{ marginTop: '12px' }}>
                        <label className="block text-sm font-medium">
                            Area (optional) <i className={getIconClass('Neighborhood')} />
                        </label>
                        <input type="text" placeholder="Area (optional)"
                            className="w-full p-2 border rounded-md"
                            {...register('neighbourhood')}
                        />
                    </div>

                    <div style={{ marginTop: '12px' }} ref={(el) => (fieldRefs.current["country"] = el)}>
                        <label className="block text-sm font-medium">
                            Country <i className={getIconClass('Country')} />
                        </label>
                        <input type="text" placeholder="Country"
                            className="w-full p-2 border rounded-md"
                            {...register('country', { onChange: (e) => setValue('country', e.target.value, { shouldValidate: true }) })}
                        />
                        {errors.country && <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.country.message}</span>}
                    </div>
                </div>
            </div>
        </div>
    );
};
